import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Svg from 'svg-inline-react';
import CloseSvg from '@src/svgs/fr-close.svg';
import ChevronLeftSvg from '@src/svgs/fr-chevron-left.svg';
import './styles.scss';

export function ModalTitle({
  title,
  className,
  showBackButton,
  showCloseButton,
  disableCloseButton,
  closeButton,
  onBack,
  onClose,
}) {
  const closeButtonRender = closeButton ? (
    React.cloneElement(closeButton, {
      onClick: () => {
        onClose && onClose();
      },
    })
  ) : (
    <Svg
      className="modal-title__close"
      onClick={() => {
        onClose && onClose();
      }}
      src={CloseSvg}
    />
  );

  return (
    <div className={classnames('modal-title', className)}>
      <div className="modal-title__content">
        <div className="modal-title__title-container">
          {showBackButton && onBack && <Svg className="modal-title__back" onClick={onBack} src={ChevronLeftSvg} />}
          {title && <h4 className="modal-title__title">{title}</h4>}
        </div>
        {!disableCloseButton && !!showCloseButton && closeButtonRender}
      </div>
    </div>
  );
}

ModalTitle.propTypes = {
  className: PropTypes.string,
  closeButton: PropTypes.node,
  disableCloseButton: PropTypes.bool,
  onBack: PropTypes.func,
  onClose: PropTypes.func,
  showBackButton: PropTypes.bool,
  showCloseButton: PropTypes.bool,
  title: PropTypes.string.isRequired,
};
